var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row-data font-weight-regular"},[_c('span',{staticClass:"pl-3 card-grid-display font-weight-regular"},[_vm._v(_vm._s(_vm.getCellData()))])])}
var staticRenderFns = []

export { render, staticRenderFns }